import { connect } from "react-redux";
import { IPlayUIStateProps } from "../..";
import {
  sharedMapDispatchToProps,
  sharedMapPropsToState
} from "../Common/Menu.redux";
import {
  IMenuMobileMapDispatchProps,
  IMenuMobileMapStateProps
} from "./MenuMobile";
import { MenuMobileView } from "./MenuMobile.view";

const mapStateToProps = (
  state: IPlayUIStateProps
): IMenuMobileMapStateProps => {
  return {
    ...sharedMapPropsToState(state)
  };
};

const mapDispatchToProps = (dispatch): IMenuMobileMapDispatchProps => {
  return {
    ...sharedMapDispatchToProps(dispatch)
  };
};

export const MenuMobile: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuMobileView);
